import { render, staticRenderFns } from "./RedirectToDiscountPopup.vue?vue&type=template&id=a199e24a&scoped=true&"
import script from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
export * from "./RedirectToDiscountPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedirectToDiscountPopup.vue?vue&type=style&index=0&id=a199e24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a199e24a",
  null
  
)

export default component.exports